// event-attendance.js

import { clearEntities } from './../../front/ducks/entities'
import store from '../../admin/store'


// Reducer

const initialState = {}

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state
    }
}


// Thunks

/**
 * Make attendance on API
 *
 * @param {string} slug - event slug
 * @param {Object} invitation
 * @param {integer} stateId
 * @param {integer} rosterPositionId
 * @return {Promise}
 */
export const createAttendance = (slug, invitation, stateId, rosterPositionId) => (
    window.axios
        .post(`${window.APP_CONFIG.REACT_APP_API_URL}api/events/${slug}/attendance?include=group,answers,user,attendanceButtons`, {
            ...invitation,
            state_id: stateId,
            roster_position_id: rosterPositionId,
            simple_response: true,
        })
        .then(({ data }) => {
            store.dispatch(clearEntities())

            return new Promise(resolve => resolve(data.data))
        })
)

/**
 * Update attendance on API
 *
 * @param {string} slug - event slug
 * @param {Object} attendance
 * @param {integer} stateId
 * @param {integer} rosterPositionId
 * @return {Promise}
 */
export const updateAttendance = (slug, attendance, stateId = null, rosterPositionId = null) => (
    window.axios
        .post(`${window.APP_CONFIG.REACT_APP_API_URL}api/events/${slug}/attendance/${attendance.id}?include=group,answers,user,attendanceButtons`, {
            ...attendance,
            simple_response: true,
            user_id: attendance.user_id,
            state_id: stateId || attendance.state_id,
            roster_position_id: rosterPositionId || attendance.rosterPositionId,
        })
        .then(({ data }) => {
            store.dispatch(clearEntities())

            return new Promise(resolve => resolve(data))
        })
)
